import { FetchHelper } from "@portal/env/stores/authTokens/FetchHelper";

const fetchHelper = new FetchHelper();

export async function fetchAllResources(nexudusToken, host) {
  const apiUrl = `https://${host.split(':')[0]}:443`;
  const url = `${apiUrl}/?_resource=Resources`;

  const headers = {
    'Content-Type': 'application/json',
  };

  if (nexudusToken) {
    headers.Authorization = `Bearer ${nexudusToken}`;
  }

  const result = await fetchHelper.fetch(url, {
    method: 'GET',
    headers,
  });
  return result.json();
}
